jQuery(document).ready(function ($) {
  const BASE_URL = 'https://api.booxlover.com/api/v1';

  // SLIDERS SETUP
  new Swiper('.swiper', {
    loop: true,
    slidesPerView: 1,
    pauseOnMouseEnter: true,
    grabCursor: true,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1024: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1140: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  });

  // GESTIONE PRE-COMPILAZIONE LOGIN
  if (window.location.pathname === '/account/login') {
    const email = localStorage.getItem('loginEmail');

    $('input[name="customer[email]"]').val(email);

    localStorage.removeItem('loginEmail');
  }

  // GESTIONE REGISTRAZIONE UTENTE
  function cleanForm(selector) {
    $(selector)
      .find('input, select, textarea')
      .each(function () {
        if ($(this).is(':checkbox') || $(this).is(':radio')) {
          $(this).prop('checked', false);
        } else if ($(this).is('select')) {
          $(this).prop('selectedIndex', 0);
        } else {
          $(this).val('');
        }
      });
  }

  // GESTIONE READ MORE CP

  $('span.cp-read-more-trigger').click(function (e) {
    e.preventDefault();
    $(`.${$(this).data('read-more-trigger')}`).toggle();

    $(this).text() === '(Leggi tutti i dettagli)'
      ? $(this).text('(Nascondi i dettagli)')
      : $(this).text('(Leggi tutti i dettagli)');
  });

  function checkFields(formDataObj) {
    let isValid = true;

    $('.error-message-text, .password-format-error').hide();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[<>@?#\!\+\-\%\(\)\[\]\$])[A-Za-z\d<>@?#\!\+\-\%\(\)\[\]\$]{8,20}$/;

    if (!passwordRegex.test(formDataObj['password'])) {
      isValid = false;
      $('.password-format-error').show();
    }

    const groups = [
      {
        fields: ['firstName', 'lastName', 'email', 'password', 'codice_GDO'],
        invalidWhen: (value) => value === '',
      },
      {
        // fields: ['regolamento', 'voucher', 'informativaPrivacy'],
        fields: ['regolamento', 'informativaPrivacy'],
        invalidWhen: (value) => value === false,
      },
    ];

    groups.forEach((group) => {
      group.fields.forEach((field) => {
        if (group.invalidWhen(formDataObj[field])) {
          isValid = false;
          $(`.error-message-text[data-input-ref="${field}"]`).show();
        }
      });
    });

    ['firstName', 'lastName'].forEach((field) => {
      const value = formDataObj[field];

      if (value && value.length < 2) {
        isValid = false;
        $(`.error-message-text[data-input-ref="${field}"]`).show();
      }
    });

    if (formDataObj.email && !emailRegex.test(formDataObj.email)) {
      isValid = false;
      $('.error-message-text[data-input-ref="email"]').show();
    }

    const cpFields = ['cp1', 'cp2', 'cp3'];
    const allChecked = cpFields.every((field) => formDataObj[field]);

    if (!allChecked) {
      isValid = false;
      $(`.error-message-text[data-input-ref="cp"]`).show();
    }

    return isValid;
  }

  $('#create_customer').submit(function (e) {
    e.preventDefault();

    $(`.error-message-text`).hide();

    const formData = {};

    $(this)
      .serializeArray()
      .forEach(function (field) {
        formData[field.name] = field.value;
      });

    $(this)
      .find('input[type=checkbox]')
      .each(function () {
        formData[this.name] = $(this).is(':checked');
      });

    if (checkFields(formData)) {
      $('#create_customer :input').prop('disabled', true);

      $.ajax({
        type: 'POST',
        url: `${BASE_URL}/customer`,
        headers: {
          Authorization: 'Basic ' + btoa('shopify-user:6096ee69-51e5-4e35-97a2-7078257b9a73'),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          password: formData.password,
          regolamento: formData.regolamento,
          voucher: true,
          informativaPrivacy: formData.informativaPrivacy,
          cp1: JSON.parse(formData.cp1),
          cp2: JSON.parse(formData.cp2),
          cp3: JSON.parse(formData.cp3),
          token: formData.codice_GDO,
        }),
        dataType: 'json',
        success: function (res) {
          localStorage.setItem('loginEmail', formData.email);
          window.location.href = '/account/login';
        },
        error: function (err) {
          const errorMsg = JSON.parse(err.responseText);

          console.log(errorMsg);

          if (errorMsg) {
            if (errorMsg.errorMessage.includes('Email è già stato scelto')) {
              $('.error-email-taken').show();
            }

            if (
              errorMsg.errorMessage.includes('errors.token.already-consumed') ||
              errorMsg.errorMessage.includes('errors.token.token-not-found')
            ) {
              $('.error-token-taken').show();
            }

            if (errorMsg.validationErrors) {
              errorMsg.validationErrors.forEach(function (ve) {
                $(`.error-message-text[data-input-ref="${ve.field}"]`).show();
              });
            }
          }
        },
        complete: function () {
          // $('#create_customer :input').prop('disabled', false);
          cleanForm('#create_customer');
        },
      });
    }
  });

  // GESTIONE FAQ
  $('.faq-item-title').click(function () {
    $(this).find('span').text() == '+' ? $(this).find('span').text('-') : $(this).find('span').text('+');
    $(this).parent().find('.faq-item-answer').slideToggle(400);
  });

  // GESTIONE PULSATE CUSTOM "AGGIUNGI AL CARRELLO"
  function updateCartCounter() {
    $.getJSON('/cart.js', function (cart) {
      $('#cart-icon-bubble .cart-count-bubble span:first-child').text(cart.item_count);
    });
  }

  $('.product-item-add-cart').click(function (e) {
    e.preventDefault();

    let variantId = $(this).data('variant');
    let productTitle = $(this).data('title');
    let productImage = $(this).data('product-image');

    $.ajax({
      type: 'POST',
      url: '/cart/add',
      data: { id: variantId, quantity: 1 },
      dataType: 'json',
      success: function (item) {
        updateCartCounter();
        $('#cart-notification #cart-notification-product').html('');

        $('#cart-notification #cart-notification-product').append(`
          <div class="book-notification-info">
            <div class="book-notification-image">
              <img src="${productImage}" />
            </div>
            <div class="book-notification-title">
              ${productTitle}
            </div>
          </div>  
        `);

        $('#cart-notification').addClass('active');
      },
      error: function (err) {
        alert('Errore: impossibile aggiungere al carrello');
        console.error(err);
      },
    });
  });

  // GESTIONE LOGHI REGISTRAZIONE
  if (window.location.pathname === '/account/register') {
    const $logo = $('.partner-landing-logo img');
    const params = new URLSearchParams(window.location.search);
    const forParam = params.get('for');

    console.log();

    if (forParam == md5('unes')) {
      const src = '/cdn/shop/files/UNES_logo.png?v=1759998042';
      $logo.attr('src', src + '&width=120');
      $logo.parent().show();
    } else if (forParam == md5('iper')) {
      const src = '/cdn/shop/files/IPER_logo.png?v=1759998042';
      $logo.attr('src', src + '&width=120');
      $logo.parent().show();
    }
  }
});
